import DealBrandErrorCode from "../../errorCodes/dealBrands"

const dealBrandsErrorHandler = (errorCode: string) => {
  switch (errorCode) {
    case DealBrandErrorCode.BrandEmptyField:
      return "errors.PBBrandEmptyField"
    case DealBrandErrorCode.BrandNotFound:
      return "errors.PBBrandNotFound"
    case DealBrandErrorCode.BrandParentNotFound:
      return "errors.PBBrandParentNotFound"
    case DealBrandErrorCode.BrandAlreadyExists:
      return "errors.PBBrandAlreadyExists"
    case DealBrandErrorCode.BrandNotParent:
      return "errors.PBBrandNotParent"
    case DealBrandErrorCode.BrandInvalid:
      return "errors.PBBrandInvalid"
    case DealBrandErrorCode.BrandParentToVariant:
      return "errors.PBBrandParentToVariant"
    default:
      return ""
  }
}

export default dealBrandsErrorHandler
